function scrollTo(options) {
  window.scrollTo(options);

  return new Promise((resolve, reject) => {
    const failed = setTimeout(() => {
      reject(new Error('Failed to scroll to top'));
    }, 2000);

    const scrollHandler = () => {
      if (window.pageYOffset === 0) {
        window.removeEventListener('scroll', scrollHandler);
        clearTimeout(failed);
        resolve();
      }
    };

    if (window.pageYOffset === 0) {
      clearTimeout(failed);
      resolve();
    } else {
      window.addEventListener('scroll', scrollHandler);
    }
  });
}

export default scrollTo;
